<!-- 组件说明 -->
<template>
  <div class="fiextop-container">
    <search class="con"></search> 
    
  </div>
</template>

<script>

import search from '../search.vue'
export default {
  components: {search},
  data() {
    return{

    }
  },

  methods: {

  },
  mounted() {},
};
</script>

<style lang='scss' scoped>
.fiextop-container {
  transition: opacity 1s;
  position: fixed;
  top: 0;
  width: 100%;
  height: 60px;
  z-index: 10000;
  background: #ffffff;
  border-bottom: 2px solid #ff3e3e;

  /deep/  .container{
        padding-top: 0;
        height: 60px;
        position: relative;
        .cart{
              top: 50%;
          transform: translateY(-50%);
          margin-top: 0;
        }
        .subject,.el-carousel{
          display: none !important;
        }
        .logo{
          height: 60px;
          @include flex-c;
          img{
          height: 40px;

          }
        }
        
    }
}

  
</style>


// WEBPACK FOOTER //
// src/components/plugins/fiexdtop.vue